import { render } from "./Event.vue?vue&type=template&id=78d8fe4e"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
script.render = render

export default script